import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { serverApi } from '../../api';
import logo from '../../assets/logo-PIT-1-768x288-fondo.png';
import { useHideMenu } from '../../hooks/useHideMenu';

const MySwal = withReactContent(Swal);

export const SuperAdminLogin = () => {
    useHideMenu(true);
    const navigate = useNavigate();

    const [tab, setTab] = useState('superadmin'); // 'superadmin' | 'vendedor'
    const [loading, setLoading] = useState(false);

    // Form superadmin
    const [saUser, setSaUser] = useState('superadmin');
    const [saPass, setSaPass] = useState('');

    // Form vendedor
    const [vendedorCode, setVendedorCode] = useState('');
    const [vendedorPass, setVendedorPass] = useState('');

    const handleLoginSuperAdmin = async (e) => {
        e.preventDefault();
        if (!saUser || !saPass) {
            return MySwal.fire('Atención', 'Ingrese usuario y contraseña', 'warning');
        }

        try {
            setLoading(true);
            const resp = await serverApi.post('/superadmin/login-superadmin', {
                usuario: saUser,
                password: saPass,
            });

            if (resp.data.ok) {
                localStorage.setItem('saToken', resp.data.token);
                localStorage.setItem('saUser', JSON.stringify(resp.data.usuario));
                MySwal.fire({
                    title: '¡Bienvenido!',
                    text: `Sesión iniciada como SuperAdmin: ${resp.data.usuario.nombreCompleto}`,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                });
                navigate('/superadmin/dashboard');
            }
        } catch (error) {
            const msg = error.response?.data?.msg || 'Error al iniciar sesión';
            MySwal.fire('Error de Autenticación', msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleLoginVendedor = async (e) => {
        e.preventDefault();
        if (!vendedorCode || !vendedorPass) {
            return MySwal.fire('Atención', 'Ingrese código de vendedor y contraseña', 'warning');
        }

        try {
            setLoading(true);
            const resp = await serverApi.post('/superadmin/login-vendedor', {
                codigoVendedor: vendedorCode,
                password: vendedorPass,
            });

            if (resp.data.ok) {
                localStorage.setItem('vendedorToken', resp.data.token);
                localStorage.setItem('vendedorUser', JSON.stringify(resp.data.usuario));
                MySwal.fire({
                    title: '¡Bienvenido!',
                    text: `Sesión iniciada como Vendedor: ${resp.data.usuario.nombreVendedor}`,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                });
                navigate('/vendedor/dashboard');
            }
        } catch (error) {
            const msg = error.response?.data?.msg || 'Error al iniciar sesión';
            MySwal.fire('Error de Autenticación', msg, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#f4f7f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
            fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: 24,
                width: '100%',
                maxWidth: 440,
                boxShadow: '0 20px 50px rgba(0,0,0,0.08)',
                overflow: 'hidden',
                border: '1px solid #e2e8f0',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)',
                    padding: '36px 28px 28px',
                    textAlign: 'center',
                    color: 'white',
                }}>
                    <img src={logo} alt="logo" style={{ height: 58, marginBottom: 12, borderRadius: 10, }} />
                    <h3 style={{ margin: 0, fontWeight: 800, fontSize: 22, letterSpacing: -0.5 }}>
                        Proyectos Informáticos y Telecomunicaciones SAS
                    </h3>
                    <p style={{ margin: '6px 0 0', opacity: 0.85, fontSize: 13 }}>
                        Portal Administrativo
                    </p>

                    {/* Tabs de Rol */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        background: 'rgba(0,0,0,0.18)',
                        borderRadius: 12,
                        padding: 4,
                        marginTop: 20,
                    }}>
                        <button
                            type="button"
                            onClick={() => setTab('superadmin')}
                            style={{
                                padding: '10px',
                                border: 'none',
                                borderRadius: 9,
                                background: tab === 'superadmin' ? '#ffffff' : 'transparent',
                                color: tab === 'superadmin' ? '#0d7367' : 'rgba(255,255,255,0.8)',
                                fontWeight: 700,
                                fontSize: 13,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                        >
                            👑 SuperAdmin
                        </button>
                        <button
                            type="button"
                            onClick={() => setTab('vendedor')}
                            style={{
                                padding: '10px',
                                border: 'none',
                                borderRadius: 9,
                                background: tab === 'vendedor' ? '#ffffff' : 'transparent',
                                color: tab === 'vendedor' ? '#0d7367' : 'rgba(255,255,255,0.8)',
                                fontWeight: 700,
                                fontSize: 13,
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                            }}
                        >
                            💼 Vendedor
                        </button>
                    </div>
                </div>

                {/* Form Body */}
                <div style={{ padding: '32px 28px' }}>
                    {tab === 'superadmin' ? (
                        <form onSubmit={handleLoginSuperAdmin}>
                            <div style={{ marginBottom: 18 }}>
                                <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                    Usuario SuperAdmin
                                </label>
                                <input
                                    type="text"
                                    value={saUser}
                                    onChange={(e) => setSaUser(e.target.value)}
                                    placeholder="usuario"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 14px',
                                        borderRadius: 12,
                                        border: '1.5px solid #cbd5e1',
                                        fontSize: 15,
                                        marginTop: 6,
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>

                            <div style={{ marginBottom: 24 }}>
                                <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                    Contraseña
                                </label>
                                <input
                                    type="password"
                                    value={saPass}
                                    onChange={(e) => setSaPass(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 14px',
                                        borderRadius: 12,
                                        border: '1.5px solid #cbd5e1',
                                        fontSize: 15,
                                        marginTop: 6,
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    width: '100%',
                                    padding: 14,
                                    borderRadius: 14,
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #0d7367 0%, #14b8a6 100%)',
                                    color: 'white',
                                    fontSize: 15,
                                    fontWeight: 800,
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 16px rgba(13,115,103,0.35)',
                                }}
                            >
                                {loading ? 'INGRESANDO...' : 'INGRESAR COMO SUPERADMIN →'}
                            </button>
                        </form>
                    ) : (
                        <form onSubmit={handleLoginVendedor}>
                            <div style={{ marginBottom: 18 }}>
                                <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                    Código Vendedor
                                </label>
                                <input
                                    type="text"
                                    value={vendedorCode}
                                    onChange={(e) => setVendedorCode(e.target.value)}
                                    placeholder="Ej: VEND-001"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 14px',
                                        borderRadius: 12,
                                        border: '1.5px solid #cbd5e1',
                                        fontSize: 15,
                                        marginTop: 6,
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>

                            <div style={{ marginBottom: 24 }}>
                                <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                    Contraseña
                                </label>
                                <input
                                    type="password"
                                    value={vendedorPass}
                                    onChange={(e) => setVendedorPass(e.target.value)}
                                    placeholder="••••••••"
                                    required
                                    style={{
                                        width: '100%',
                                        padding: '12px 14px',
                                        borderRadius: 12,
                                        border: '1.5px solid #cbd5e1',
                                        fontSize: 15,
                                        marginTop: 6,
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            </div>

                            <button
                                type="submit"
                                disabled={loading}
                                style={{
                                    width: '100%',
                                    padding: 14,
                                    borderRadius: 14,
                                    border: 'none',
                                    background: 'linear-gradient(135deg, #0d7367 0%, #14b8a6 100%)',
                                    color: 'white',
                                    fontSize: 15,
                                    fontWeight: 800,
                                    cursor: 'pointer',
                                    boxShadow: '0 4px 16px rgba(13,115,103,0.35)',
                                }}
                            >
                                {loading ? 'INGRESANDO...' : 'INGRESAR COMO VENDEDOR →'}
                            </button>
                        </form>
                    )}

                    <div style={{ textAlign: 'center', marginTop: 24, fontSize: 12, color: '#94a3b8' }}>
                        &copy; 2026 TicketApp Multi-Tenant · Marca Blanca
                    </div>
                </div>
            </div>
        </div>
    );
};
